// Tiny, configurable logger so we don't have raw `console.*` calls scattered around.
// In production, only warnings & errors are emitted (debug & info are no-ops).
// In development, everything is forwarded to the browser console for debuggability.

const isProd = process.env.NODE_ENV === "production";

const noop = () => {};

export const logger = {
  debug: isProd ? noop : (...args) => console.debug(...args),
  info: isProd ? noop : (...args) => console.info(...args),
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};
